import { Box } from "@mui/material";
import CustomText, { textStyles } from "./CustomText";
import CustomButton from "./CustomButton";
import erroscreenicon from "../assets/Dashboard/errorscreenicon.svg";
import { useTranslation } from "react-i18next";
const AnyError = () => {
    const { t } = useTranslation();
  return (
    <Box
      sx={{
        p: 4,
        py:8,
        mt: 10,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img src={erroscreenicon} alt="Error Icon" width={80} height={80} />

      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize:"32px",
          color: "#2C384C",
          textAlign: "center",
          mt: 3,
        }}
      >
             {t("error_screen.title")}
      </CustomText>

      <CustomText
        sx={{
          ...textStyles.body4,
          mt: 3,
          color: "#8B8D97",
          fontSize:'22px',
          textAlign: "center",
          maxWidth: 900,
          lineHeight:1.5,
        }}
      >
         {t("error_screen.part1")} <br />
            {t("error_screen.part2")}{" "}
        <span style={{ color: "#0072CE", cursor: "pointer" }}>
         {t("error_screen.click_here")}
        </span>
        .
      </CustomText>

      <CustomButton
        label={t("error_screen.button")}
        sx={{ mt: 3, px: 3, py: 1 }}
        onClick={() => window.history.back()}
      />
    </Box>
  );
};

export default AnyError;